import * as React from 'react';
import { useState } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import blogIcon from "../../assets/main/blogIcon.png";
import InstagramIcon from '@mui/icons-material/Instagram';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});



const MainOffice = () => {

  const navigate = useNavigate();

  return (
    <React.Fragment>
      <Accordion  sx={{ width: '100%', mt: 3, bgcolor:'transparent', boxShadow:'none', ':before':{bgcolor:'transparent'} }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{'& .MuiAccordionSummary-content': {flexGrow:0}}}
        >
          <Typography sx={{ fontSize: 14, mb: '5px', fontWeight: 700 }}>(주) 듀얼헬스케어</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ textAlign: 'center', }}>

            <Box>
              <Typography sx={{ fontSize: 14, mb: '5px' }}>대전광역시 서구 문정로 30</Typography>
              <Typography sx={{ fontSize: 14, mb: '5px' }}>통신판매업신고번호 : 제2020-대전유성-1103호</Typography>
              <Typography sx={{ fontSize: 14 }}>사업자번호 : 111-86-01943</Typography>
              <Typography sx={{ fontSize: 14, mb: '5px' }}>전화번호 : 1661-2645</Typography>
              <Typography sx={{ fontSize: 14 }}>문의 : help@dual.health</Typography>
            </Box>

            <Stack direction={'row'} sx={{ mt: 2 }}>
              <a href="https://m.blog.naver.com/dualhealth_official" target="_blank" style={{ width: '50%', textAlign: 'right', marginRight: '20px' }}><img alt="Blog" src={blogIcon} style={{ width: '30px', opacity: '0.7' }} />  </a>
              <a href="https://www.instagram.com/dualhealth_official" target="_blank" ><InstagramIcon sx={{ color: '#929292', fontSize: 32 }} /></a>
            </Stack>

            <Stack direction={'row'} justifyContent={'center'} sx={{ mt: 2 }}>
              <Button onClick={() => navigate('../Policy/Terms')}>
                <Typography sx={{ fontSize: 12, color: '#555' }}>Terms and conditions</Typography>
              </Button>
              <Button onClick={() => navigate('../Policy/Private')}>
                <Typography sx={{ fontSize: 12, color: '#555' }}>Privacy policy</Typography>
              </Button>
            </Stack>
          </Box>
        </AccordionDetails>
      </Accordion>





    </React.Fragment>
  );
}


export default MainOffice;

